import { Bone, Spine } from '@esotericsoftware/spine-pixi-v8';
import { MagicLayout } from '@magic/layout';
import { type Paylines, paylines } from 'config/paylines.config';

export class PaylineController {
    private sourcePayline: Spine;
    private paylinesPool: Spine[] = [];
    private activePaylines: Spine[] = [];

    constructor(private spineLayout: MagicLayout) {
        const originalPayline = this.spineLayout.spines.get('payline');

        if (!originalPayline) {
            throw new Error(`Payline spine not found`);
        }

        this.sourcePayline = originalPayline;

        Array.from({ length: 10 }, () => this.getSpineChunk());

        // spineLayout.scene.addSlotChild('root', 'paylines', this.originalPayline);
    }

    getSpineChunk(): {
        spine: Spine;
        bone1: Bone;
        bone2: Bone;
    } {
        let spine: Spine;

        if (this.paylinesPool.length === 0) {
            const id = this.activePaylines.length + 1;

            spine = this.spineLayout.spine.clone(this.sourcePayline, `payline${id}`);

            this.activePaylines.push(spine);
        } else {
            spine = this.paylinesPool.pop() as Spine;
        }

        const bone1 = spine.skeleton.findBone('point1') as Bone;
        const bone2 = spine.skeleton.findBone('point2') as Bone;

        if (!bone1 || !bone2) {
            throw new Error(`Payline bones not found`);
        }

        return { spine, bone1, bone2 };
    }

    async showPaylines(paylinesIDs: Paylines) {
        if (paylinesIDs.length === 0 || !paylinesIDs[0]) {
            return;
        }

        // console.log(`🧟 showPaylines ${paylinesIDs}`);

        // const symbolSlots = this.spineLayout.spine.getSlotsByNamePattern('spine_symbol');
        // const reels = this.spineLayout.spine.getSpinesByNamePattern('reel');

        for (const payLineID of paylinesIDs) {
            const paylineData = paylines[payLineID];
            // console.log(`🧟 payline ${payLineID}`);

            for (let reelID = 0; reelID < paylineData.length - 1; reelID++) {
                const chunk = {
                    p1: { x: reelID, y: paylineData[reelID] },
                    p2: { x: reelID + 1, y: paylineData[reelID + 1] },
                };

                const spineChunk = this.getSpineChunk();
                // TODO: get created symbols here
                // TODO: get symbol by its reel/row position (0,1)
                // TODO: use getBonesGlobalPositionsByNamePattern to detect symbols globasl position
                // TODO: update payline chunk positions based on symbol positions
                // const symbols = this.spineLayout.spine.getBonesByNamePattern('symbol');
                // const symbols = this.spineLayout.spine.getBonesGlobalPositionsByNamePattern('symbol');

                console.log(`!!! chunk`, spineChunk, chunk);

                // TODO: convert reel/y to x/y coordinates
                // TODO: figureout why there is only 1 chunk spine instance on scene
                // spineChunk.bone1.x = chunkData[0].p1.x;
                // spineChunk.bone2.x = chunkData[0].p2.x;

                // spineChunk.bone1.y = chunk.p1.y;
                // spineChunk.bone2.y = chunk.p2.y;

                await spineChunk.spine.state.setAnimation(0, 'show', false);
            }
        }
    }
}
